<div class="container">

  <div class="portalCard">

    <ng-container *ngIf="isIsselhorsterReady(); else fallback">
      @if (isIsselhorsterReady()) {
        <vgv-app [attr.application-id]="applicationId()"></vgv-app>
      }
    </ng-container>
    <ng-template #fallback>
      <div style="opacity:.7">Wohngebäude nicht aktiviert.</div>
    </ng-template>
  </div>
</div>
